import { isValidAsin } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const AmazonOfferContent: SDEContent = {
  projectType: 'async_amazon_offer',
  projectCategory: 'amazon',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/amazon/offers/v1`;
  },
  docsSection: 'amazon-offers-api',
  docsSectionTitle: 'Amazon Offers API',
  docsSectionAsync: 'amazon-offers-api-async',
  docsSectionAsyncTitle: 'Amazon Offers API (Async)',
  inputKey: 'asin',
  inputsKey: 'asins',
  validatorFunction: isValidAsin,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'ASINs',
      listLiteralInputPlaceholder: 'Enter one ASIN per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input ASINs',
      inputSectionDescription: "Based on the data type you selected, you need to add ASINs to begin scraping Amazon.",
    },
    projectContent: {
      title: 'Amazon offers',
      description: 'Extract product offer details from Amazon with ASINs such as seller, products and prices.',
      icon: 'amazon',
      // ---
      inputTitle: 'Asin',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input ASINs',
      inputSectionDescription: 'Enter Amazon ASINs to begin scraping Amazon.',
    },
    projectContent: {
      title: 'Amazon offers',
      description: 'Extract product offer details from Amazon with ASINs such as seller, products and prices.',
      icon: 'amazon',
    },
    enterInputsPlaceholder: 'B06X3WKY59',
    enterInputsMessage: 'Enter ASIN for scraping',
    codeViewPlaceHolder: 'Please provide a valid ASIN',
    dropdownTitle: 'Amazon Offers'
  }
};
